import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=24a15148&scoped=true&"
import script from "./PersonCard.vue?vue&type=script&lang=js&"
export * from "./PersonCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonCard.vue?vue&type=style&index=0&id=24a15148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a15148",
  null
  
)

component.options.__file = "PersonCard.vue"
export default component.exports